<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <div class="card">
      <el-button type="primary" @click="increment">count is {{ count }}</el-button>
      <p>
        Edit <code>components/HelloWorld.vue</code> to test HMR
      </p>
    </div>

    <p>
      这是一个示例组件，已调整为 Vue 2 语法以兼容当前项目。
    </p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      count: 0
    }
  },
  methods: {
    increment() {
      this.count++
    }
  }
}
</script>

<style scoped>
.read-the-docs {
  color: #888;
}
.card {
  margin: 12px 0;
}
</style>
